import { CustomPrompt } from '../../shared/interfaces/CustomPrompt';

// Active while the composer text starts with "/" and stays on one line —
// spaces are allowed so multi-word titles can be searched ("/cadeia produtiva").
const SLASH_RE = /^\/([^\n]*)$/;

/**
 * Detect the slash-command state of the composer (feature B). The menu is
 * active when the text begins with "/" (spaces allowed, newline closes it);
 * the captured query is whatever follows the slash.
 */
export function parseSlashQuery(text: string): { active: boolean; query: string } {
  const m = SLASH_RE.exec(text ?? '');
  if (!m) return { active: false, query: '' };
  return { active: true, query: m[1] };
}

// Same accent-stripping normalization the prompt library search uses.
const normalize = (s: string) => (s || '').toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '');

/**
 * Case- and accent-insensitive prompt search (feature B).
 *
 * The query is split into tokens; EVERY token must appear in the title, the
 * category name or the description (AND semantics). Results are ranked:
 * title-prefix > title substring > category/description, so the most likely
 * prompt comes first.
 */
export function filterPromptsByQuery(prompts: CustomPrompt[], query: string): CustomPrompt[] {
  const tokens = normalize(query).split(/\s+/).filter(Boolean);
  if (tokens.length === 0) return prompts;
  const scored: { p: CustomPrompt; score: number }[] = [];
  for (const p of prompts) {
    const title = normalize(p.title);
    const desc = normalize((p as any).description || '');
    const cat = normalize((p as any).categoryName || '');
    let score = 0;
    let ok = true;
    for (const t of tokens) {
      if (title.includes(t)) score += title.startsWith(t) ? 3 : 2;
      else if (cat.includes(t) || desc.includes(t)) score += 1;
      else { ok = false; break; }
    }
    if (ok) scored.push({ p, score });
  }
  scored.sort((a, b) => b.score - a.score);
  return scored.map(s => s.p);
}
